import React from 'react';
export function FooterSection() {
  return <footer className="bg-white py-12 px-4 border-t border-soft-gray text-center" data-id="element-91">
      <div className="max-w-4xl mx-auto" data-id="element-92">
        <h3 className="text-xl font-bold text-navy mb-4" data-id="element-93">
          Método Noches de Paz™
        </h3>
        <p className="text-sm text-navy/60 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-94">
          Este material es de uso personal y tiene fines informativos. No
          reemplaza la consulta con profesionales de la salud. Si tenés dudas
          sobre la salud de tu bebé, consultá siempre a tu pediatra.
        </p>
        <p className="text-xs text-navy/40" data-id="element-95">
          © Método Noches de Paz™ — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}